import showFirmen from './components/firmen/showFirmen.vue'
import showAdressen from './components/adressen/showAdressen.vue'
import showMarken from './components/marken/showMarken.vue'
import singleFirmen from './components/firmen/singleFirmen.vue'
import singleMarken from './components/marken/singleMarken.vue'
import editFirmen from './components/firmen/editFirmen.vue'
import editMarken from './components/marken/editMarken.vue'
import editAdressen from './components/adressen/editAdressen.vue'
import createMarken from './components/marken/createMarken.vue'
import createFirmen from './components/firmen/createFirmen.vue'
import createAdressen from './components/adressen/createAdressen.vue'
import login from './components/auth/login.vue'
import register from './components/auth/register.vue'
import profile from './components/auth/profile.vue'
import passport from './components/passport/Passport.vue'
import markenapi from './components/admin/config/Markenapi.vue'
import dashboard from './components/dashboard/showBoard.vue'
import fileimport from './components/admin/import/import.vue'

export default[
   
    {
        path: '/',
        redirect: '/login',        
        name: 'start'
       
    },
    {
        path: '/admin/import/import',
        component: fileimport,        
        name: 'fileimport',
        meta: {
            forAuth: true
        }
       
    },    
    {
        path: '/dashboard',
        component: dashboard,        
        name: 'dashboard',
        meta: {
            forAuth: true
        }
       
    },    
    {
        path: '/admin/config/markenapi',
        component: markenapi,
        name: 'markenapi',
        meta: {
            forAuth: true
        }
        
    },
    {
        path: '/admin/passport',
        component: passport,
        name: 'passport',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/login',
        component: login,
        name: 'login',
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/register',
        component: register,
        name: 'register',
        meta: {
            forVisitors: true
        }
    },
    {
        path: '/firmen',
        component: showFirmen,
        name: 'firmen',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/marken',
        component: showMarken,
        name: 'marken',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/adressen',
        component: showAdressen,
        name: 'adressen',
        meta: {
            forAuth: true
        }        
    },
    
    {
        path: '/firmen/:id/edit',
        component: editFirmen,
        name: 'firmen_edit',        
        meta: {
            forAuth: true
        }
    },
    {
        path: '/firmen/create',        
        component: createFirmen,
        name: 'firmen_create',        
        meta: {
            forAuth: true
        }
    },
    {
        path: '/marken/:id/edit',
        component: editMarken,
        name: 'marken_edit',        
        meta: {
            forAuth: true
        }
    },
    {
        path: '/marken/create',        
        component: createMarken,
        name: 'marken_create',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/adressen/:id/edit',        
        component: editAdressen,
        name: 'adressen_edit',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/adressen/create',        
        component: createAdressen,
        name: 'adressen_create',
        meta: {
            forAuth: true
        }
    },
    {
        path: '/profile',        
        component: profile,
        name: 'profile',
        meta: {
            forAuth: true
        }
    },
    
]



// WEBPACK FOOTER //
// ./src/routes.js